import {
  BOW_TIE_BORDER_COLOR,
  BOW_TIE_HORIZONTAL_LINE,
  BOW_TIE_SIDE,
} from '../constants';
import BowTieControl from './BowTieControl';

function BowTieBranch({ branch, side, index, disabled, onControlClick }) {
  const name = branch.nome;
  const branchId = branch?.id ?? index;
  const isPreventive = side === BOW_TIE_SIDE.PREVENTIVO;
  const controles = branch?.controles || [];
  const hasControls = controles.length > 0;
  const node = (
    <div
      className={`tw:relative tw:z-1 tw:flex tw:min-h-14.5 tw:items-center tw:rounded-lg tw:border-2 tw:border-solid tw:bg-white tw:px-3 tw:py-2.5 tw:text-[13px]/[1.35] tw:font-semibold ${
        BOW_TIE_BORDER_COLOR[isPreventive ? 'cause' : 'consequence']
      }`}
      title={name.length > 80 ? name : undefined}
    >
      {hasControls && (
        <span
          className={`${BOW_TIE_HORIZONTAL_LINE} tw:w-3 ${
            isPreventive
              ? 'tw:left-[calc(100%+2px)]'
              : 'tw:right-[calc(100%+2px)]'
          }`}
          aria-hidden="true"
        />
      )}
      {name}
    </div>
  );
  const controlesList = (
    <div
      className={`tw:relative tw:z-1 tw:flex tw:flex-col tw:gap-2 tw:not-empty:after:pointer-events-none tw:not-empty:after:absolute tw:not-empty:after:top-1/2 tw:not-empty:after:h-px tw:not-empty:after:w-2.75 tw:not-empty:after:bg-[#dfe7ef] ${
        isPreventive
          ? 'tw:after:left-[calc(100%+8px)]'
          : 'tw:after:right-[calc(100%+8px)]'
      }`}
    >
      {controles.map((control, controlIndex) => (
        <BowTieControl
          key={`${side}-${branchId}-${
            control?.riscoPontoControleId ?? control?.id ?? controlIndex
          }`}
          control={control}
          side={side}
          branch={branch}
          disabled={disabled}
          onClick={onControlClick}
        />
      ))}
    </div>
  );

  return (
    <div
      className={`tw:group/branch tw:relative tw:grid tw:min-h-19 tw:items-center tw:gap-5.5 ${
        isPreventive
          ? 'tw:grid-cols-[205px_255px]'
          : 'tw:grid-cols-[255px_205px]'
      }`}
    >
      <span
        className={`tw:pointer-events-none tw:absolute tw:inset-y-0 tw:w-px tw:before:absolute tw:before:inset-x-0 tw:before:-top-2.75 tw:before:bottom-1/2 tw:before:bg-[#dfe7ef] tw:group-first/branch:before:hidden tw:after:absolute tw:after:inset-x-0 tw:after:top-1/2 tw:after:-bottom-2.75 tw:after:bg-[#dfe7ef] tw:group-last/branch:after:hidden ${
          isPreventive ? 'tw:-right-4.5' : 'tw:-left-4.5'
        }`}
        aria-hidden="true"
      />
      {!hasControls && (
        <span
          className={`${BOW_TIE_HORIZONTAL_LINE} ${
            isPreventive ? 'tw:-right-4.5 tw:left-0' : 'tw:right-0 tw:-left-4.5'
          }`}
          aria-hidden="true"
        />
      )}
      {isPreventive ? (
        <>
          {node}
          {controlesList}
        </>
      ) : (
        <>
          {controlesList}
          {node}
        </>
      )}
    </div>
  );
}

export default BowTieBranch;
